import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/9_card_back_chinese_cat/9_card_back_chinese_cat"
 * Contains 1 texture(s)
 */
export class CardsBacks9CardBackChineseCatAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/9_card_back_chinese_cat/9_card_back_chinese_cat';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '9_chinese_cat.png'
    ] as const;
}
